import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ESubscriptionLimitType } from 'shared/common/packages/EarlyAccessPaywall/shared/types/context';
import { useContext } from 'shared/common/packages/EarlyAccessPaywall/shared/utils/useContext';

import { useCheckContactsAccess } from '../../hooks/useCheckContactsAccess';
import { clearOfferId } from '../../reducers/earlyAccessContacts';
import { selectContactsAccessOfferId } from '../../selectors/earlyAccessContacts';

export const ContactsAccessChecker: React.FC = () => {
  const dispatch = useDispatch();
  const offerId = useSelector(selectContactsAccessOfferId);
  const { checkContactsAccess } = useCheckContactsAccess();
  const context = useContext();

  React.useEffect(() => {
    if (offerId) {
      checkContactsAccess({
        offerId,
        limitType: ESubscriptionLimitType.PhoneNumber,
      }).catch(() => {
        dispatch(clearOfferId());
      });
    }
  }, [offerId, checkContactsAccess, dispatch]);

  React.useEffect(() => {
    if (!context.open && offerId) {
      dispatch(clearOfferId());
    }
  }, [context.open, offerId, dispatch]);

  return null;
};
